import { t as e } from "./utils-DiFe-_ei.js";
import { t } from "./dist-B6xjZgdF.js";
import { t as n } from "./dist-B3lndwlS.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-label@2.1.12_@types+react-dom@19.2.3_@types+react@19.2.17__@types+react_8b17aa2f7ffbbc79710c90854166ce86/node_modules/@radix-ui/react-label/dist/index.mjs
var a = Object.defineProperty, o = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ ((e, t) => a(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	return /* @__PURE__ */ i(n.label, {
		...e,
		ref: t,
		onMouseDown: (t) => {
			t.target.closest("button, input, select, textarea") || (e.onMouseDown?.(t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
		}
	});
}, "Label")), s = t("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 block"), c = r.forwardRef(({ className: t, htmlFor: n, onClick: r, ...a }, c) => /* @__PURE__ */ i(o, {
	ref: c,
	htmlFor: n,
	className: e(s(), t),
	onClick: (e) => {
		r?.(e), n && document.getElementById(n)?.focus();
	},
	...a
}));
c.displayName = o.displayName;
//#endregion
export { c as t };

//# sourceMappingURL=label-DBGQWsW2.js.map